import { cn } from '@/lib/utils'

const ORIGIN_STYLES: Record<string, string> = {
	VEREAGIR: 'bg-kaefer-sapphire-blue/15 text-kaefer-sapphire-blue',
	INTERACAO: 'bg-kaefer-grass-green/15 text-kaefer-forest-green',
	DIRECIONADA: 'bg-kaefer-violet/15 text-kaefer-violet',
	CARTAO: 'bg-kaefer-honey-yellow/25 text-kaefer-dark-grey',
}

export function ModuleTag({
	origin,
	label,
}: {
	origin: string
	label: string
}) {
	return (
		<span
			className={cn(
				'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-semibold whitespace-nowrap',
				ORIGIN_STYLES[origin] ??
					'bg-kaefer-light-silver/60 text-kaefer-dark-grey',
			)}
		>
			{label}
		</span>
	)
}
